import { render, staticRenderFns } from "./ItemOptionSegment.vue?vue&type=template&id=c7138fc6&scoped=true&"
import script from "./ItemOptionSegment.vue?vue&type=script&lang=js&"
export * from "./ItemOptionSegment.vue?vue&type=script&lang=js&"
import style0 from "./ItemOptionSegment.vue?vue&type=style&index=0&id=c7138fc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7138fc6",
  null
  
)

export default component.exports